import { useEffect, useRef, useState } from 'react'
import {
  SDrawerOrModal,
  SFormUploadImage,
  SGeneralForms,
  SMessage,
  SSegmentedTabs,
  SSteps,
} from 'shj-components'
import styles from '../../index.module.less'
import { Button, Cascader, Form, FormInstance, message, Select, Upload } from 'antd'
import { getChildrenDicts } from '@/services/index'
import { getBankList, getBankAreaList, getBankBranchList } from '@/services/fmsConfig'
import { GeneralFormRefProps } from 'shj-components/dist/es/SGeneralForms/type'
import {
  startRefundNonRetail,
  startRefundDeposit,
  startRefundDesign,
  findCanRefundTrans,
  orderDetail,
} from '@/services/order'
import { UploadOutlined } from '@ant-design/icons'
import { getToken } from 'shj-utils'
import { getXTransferInsideTenantId } from '@/utils/common'
import { baseURL } from '@/api'
interface IProps {
  title: string
  open: boolean
  orderId: string
  setOpen: (open: boolean) => void
  detailsInfo: Record<string, any>
}
export default function ReFundDrawer(prpos: IProps) {
  const { open, title, orderId, setOpen, detailsInfo } = prpos
  const formRef: any = useRef<GeneralFormRefProps>()
  const [bankAreaList, setBankAreaList] = useState<any>([])
  const [bankList, setBankList] = useState<any>([])
  const [bankBranchList, setBankBranchList] = useState<any>([])
  const [reasonList, setReasonList] = useState<any>([])
  const [fileList, setFileList] = useState<any>([])

  const [designFeeAmount, setDesignFeeAmount] = useState<any>(0)
  const designFeePaymentAmount = Form.useWatch(
    'designFeePaymentAmount',
    formRef.current?.onFormRef()
  )
  const [btnLoading, setBtnLoading] = useState(false)
  const designFeeRefundAmount = Form.useWatch('designFeeRefundAmount', formRef.current?.onFormRef())
  const giftCostAmount = Form.useWatch('giftCostAmount', formRef.current?.onFormRef())
  const orderRefundType = Form.useWatch('refundType', formRef.current?.onFormRef())
  const paymentAmount = Form.useWatch('paymentAmount', formRef.current?.onFormRef())
  useEffect(() => {
    if (orderRefundType === 'refundTypeDesignFeeOrder') {
      formRef.current
        ?.onFormRef()
        ?.setFieldValue(
          'designerFeePenaltyAmount',
          (
            (designFeePaymentAmount || 0) -
            (designFeeRefundAmount || 0) -
            (giftCostAmount || 0)
          ).toFixed(2)
        )
    } else if (orderRefundType === 'refundTypeOrder') {
      // 退单：赠品扣除金额算在了退工程款中，不在退单中的退设计费中处理
      formRef.current
        ?.onFormRef()
        ?.setFieldValue(
          'designerFeePenaltyAmount',
          +((designFeePaymentAmount || 0) - (designFeeRefundAmount || 0)).toFixed(2)
        )
    }
  }, [designFeeRefundAmount, giftCostAmount])

  const refundTypeList = [
    {
      value: 'refundTypeOrder',
      label: '退单',
    },
    {
      value: 'refundTypeDeposit',
      label: '退定金',
    },
    {
      value: 'refundTypeDesignFeeOrder',
      label: '退设计费',
    },
  ]

  useEffect(() => {
    if (open) {
      orderDetail(orderId).then((res: any) => {
        console.log(res)
        formRef.current?.onFormRef()?.setFieldsValue({
          accountName: res.customerName,
        })
      })
    } else {
      formRef.current?.onFormRef()?.resetFields()
    }
  }, [open])
  const getBankAddress = () => {
    const { bankAreaCode, bankCode } = formRef.current?.onFormRef()?.getFieldsValue() || {}
    if (bankAreaCode && bankCode) {
      getBankBranchList({ bankCode: bankCode.value, areaCode: bankAreaCode }).then(res => {
        // setBankBranchList(res)
        formRef.current?.updateState({
          bankBranchList: res,
        })
        formRef.current?.onFormRef().resetFields(['branchCode'])
      })
    }
  }
  const findCanRefundTransFn = async refundType => {
    findCanRefundTrans({
      orderId,
      refundType,
    }).then((res: any) => {
      console.log(res)
      const data = res.dtlList
      data.map((item, index) => {
        if (res.refundType === 'refundTypeOrder') {
          if (item.transactionType === 'constructionFee') {
            formRef.current?.onFormRef()?.setFieldsValue({
              engineeringPaymentAmount: item.canRefundAmount,
            })
          } else if (item.transactionType === 'designFee') {
            formRef.current?.onFormRef()?.setFieldsValue({
              designFeePaymentAmount: item.canRefundAmount,
            })
            setDesignFeeAmount(item.canRefundAmount)
          }
        } else if (res.refundType === 'refundTypeDeposit') {
          if (item.transactionType === 'constructionFee') {
            formRef.current?.onFormRef()?.setFieldsValue({
              paymentAmount: item.canRefundAmount,
            })
          }
        } else if (res.refundType === 'refundTypeDesignFeeOrder') {
          if (item.transactionType === 'designFee') {
            // 设计费
            formRef.current?.onFormRef()?.setFieldsValue({
              designFeePaymentAmount: item.canRefundAmount,
              designFeeRefundAmount: item.canRefundAmount,
            })
          }
        }
      })
    })
  }
  const getOptions = async () => {
    const dicRes: any = await getChildrenDicts(['BackMoneyReason', 'BreakContractPeople'])
    const bankLists = await getBankList({
      orderBys: [
        {
          columnName: '',
          asc: false,
        },
      ],
    })
    const bankAreaLists = await getBankAreaList({
      orderBys: [
        {
          columnName: '',
          asc: false,
        },
      ],
    })
    let reasonList = dicRes?.length
      ? dicRes?.filter((item: any) => item.priKey === 'BackMoneyReason')?.[0]?.children
      : []
    reasonList = filterData(reasonList)
    const defaulterList = dicRes?.length
      ? dicRes
          ?.filter((item: any) => item.priKey === 'BreakContractPeople')?.[0]
          ?.children?.map(item => ({ label: item.name, value: item.priKey }))
      : []
    setBankAreaList(bankAreaLists)
    setBankList(bankLists)
    setReasonList(reasonList)

    return Promise.resolve({
      bankList: bankLists,
      bankAreaList: bankAreaLists,
      defaulterList,
    })
  }
  const filterData = data => {
    data = data?.filter(item => {
      if (item?.children?.length) {
        item.children = filterData(item.children)
      }
      return item.enabled
    })
    return data
  }
  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then((values: any) => {
        console.log(values)
        console.log(fileList)
        values.fileInfos = fileList?.length
          ? fileList?.map(item => {
              return {
                fileName: item.name,
                filePath: item.url,
              }
            })
          : null
        values.orderId = orderId
        values.bankName = values.bankCode.label
        values.bankCode = values.bankCode.value
        values.branchName = values.branchCode.label
        values.branchCode = values.branchCode.value
        ;[values.reason, values.reasonTwo] = values?.reason
        if (values.refundType == 'refundTypeOrder') {
          setBtnLoading(true)
          startRefundNonRetail({ ...values, ignoreWarning: false })
            .then((res: any) => {
              if (res?.hasWarning) {
                SMessage.confirm({
                  title: '退单发起后，关联的抵扣券将失效，流程撤回，抵扣券也不会恢复',
                  content: <span>抵扣券：{res?.couponName}</span>,
                  onOk: () => {
                    return startRefundNonRetail({ ...values, ignoreWarning: true }).then((res: any) => {
                      message.success(res.message || '操作成功')
                      setOpen(false)
                    })
                  },
                })
              } else {
                message.success(res.message || '提交成功')
                setOpen(false)
              }
            })
            .finally(() => {
              setBtnLoading(false)
            })
        } else if (values.refundType === 'refundTypeDeposit') {
          if (values.refundAmount + values.giftCostAmount > values.paymentAmount) {
            return message.warning('应退金额加赠品扣除金额不能大于交款金额')
          }
          setBtnLoading(true)
          startRefundDeposit({ ...values })
            .then((res: any) => {
              message.success(res.message || '提交成功')
              setOpen(false)
            })
            .finally(() => {
              setBtnLoading(false)
            })
        } else if (values.refundType === 'refundTypeDesignFeeOrder') {
          if (
            values.designerFeePenaltyAmount + values.designFeeRefundAmount + values.giftCostAmount >
            values.designFeePaymentAmount
          ) {
            return message.warning(
              '设计费退款金额+设计费违约金额+赠品扣除金额不能高于设计费收款金额'
            )
          }
          setBtnLoading(true)
          startRefundDesign({ ...values })
            .then((res: any) => {
              message.success(res.message || '提交成功')
              setOpen(false)
            })
            .finally(() => {
              setBtnLoading(false)
            })
        }
      })
  }
  const onbeforeUpload = val => {
    const maxSize = 1024 * 1024 * 50
    if (val && val.size > maxSize) {
      message.warning(val.name + '文件超过50M，上传失败')
      return false
    }
  }
  const onUploadChange = ({ file, fileList }) => {
    let list: any = []
    const maxSize = 1024 * 1024 * 50
    if (file && file.size > maxSize) {
      return
    }
    setFileList([...fileList])
    if (file && file.status === 'done') {
      let data = file.response.data
      list = [
        {
          uid: file?.uid,
          name: data?.originalFilename,
          url: data?.fileUrl,
        },
      ]
      setFileList([...list])
    }
  }
  return (
    <div>
      <SDrawerOrModal
        title={title}
        mode="drawer"
        open={open}
        onCancel={() => {
          setFileList([])
          setOpen(false)
        }}
        onOk={onSubmit}
        width={1010}
        okText="提交"
        loading={btnLoading}
      >
        <div className={styles.addQuotationDrawer}>
          <SGeneralForms
            ref={formRef}
            httpOptionsFn={getOptions}
            layout={'vertical'}
            initialValues={{ realRefundFlag: true }}
            configs={[
              {
                formItem: [
                  {
                    label: '退款类型',
                    name: 'refundType',
                    spanCol: 12,
                    required: true,
                    // type: 'select',
                    type: 'radio',
                    comConfig: {
                      options: refundTypeList,
                      onChange: async (e: any) => {
                        findCanRefundTransFn(e.target.value)
                      },
                    },
                  },
                  {
                    label: '交款金额（元）',
                    name: 'paymentAmount',
                    isHideItem: orderRefundType === 'refundTypeDeposit' ? false : true,
                    spanCol: 12,
                    required: true,
                    isDetail: true,
                  },
                  {
                    label: '应退金额（元)',
                    name: 'refundAmount',
                    isHideItem: orderRefundType === 'refundTypeDeposit' ? false : true,
                    spanCol: 12,
                    required: true,
                    type: 'inputNumber',
                    comConfig: {
                      min: 0.01,
                      max: paymentAmount,
                      precision: 2,
                    },
                  },
                  {
                    label: '工程款交款金额（元）',
                    name: 'engineeringPaymentAmount',
                    isHideItem: orderRefundType === 'refundTypeOrder' ? false : true,
                    spanCol: 12,
                    required: true,
                    // rules: [{ required: true, message: '请填写' }],
                    // children: (text: any, record: any) => {
                    //   return <div>{text}</div>
                    // },
                    isDetail: true,
                    // comConfig: { disabled: true },
                  },
                  {
                    label: '设计费交款金额（元）',
                    name: 'designFeePaymentAmount',
                    isHideItem: orderRefundType === 'refundTypeDesignFeeOrder' ? false : true,
                    spanCol: 12,
                    required: true,
                    comConfig: { disabled: true },
                  },
                  {
                    label: '设计费应退金额（元）',
                    name: 'designFeeRefundAmount',
                    isHideItem: orderRefundType === 'refundTypeDesignFeeOrder' ? false : true,
                    type: 'inputNumber',
                    spanCol: 12,
                    required: true,
                    comConfig: {
                      min: 0,
                      max: designFeePaymentAmount,
                      precision: 2,
                    },
                  },
                  {
                    label: '设计费违约金（元）',
                    name: 'designerFeePenaltyAmount',
                    isHideItem: orderRefundType === 'refundTypeDesignFeeOrder' ? false : true,
                    type: 'inputNumber',
                    spanCol: 12,
                    comConfig: {
                      disabled: true,
                    },
                  },
                  {
                    label: '违约责任人',
                    name: 'defaulter',
                    spanCol: 12,
                    type: 'select',
                    data: 'defaulterList',
                    isHideItem: orderRefundType === 'refundTypeOrder' ? false : true,
                  },
                  {
                    label: '工程款违约金（元）',
                    name: 'engineeringPenalty',
                    type: 'inputNumber',
                    spanCol: 12,
                    isHideItem: orderRefundType === 'refundTypeOrder' ? false : true,
                    comConfig: {
                      disabled: !orderRefundType ? true : false,
                      min: 0,
                      precision: 2,
                      onChange: e => {
                        console.log(e)
                        console.log(
                          formRef.current?.onFormRef()?.getFieldValue('engineeringPaymentAmount')
                        )
                        const all = formRef.current?.onFormRef()?.getFieldsValue()
                        console.log(all)
                        all.giftCostAmount = all.giftCostAmount || 0
                        const num = all.engineeringPaymentAmount - e - all.giftCostAmount
                        formRef.current?.onFormRef()?.setFieldsValue({
                          engineeringRefundAmount: num,
                        })
                      },
                    },
                  },
                  {
                    label: '赠品扣除金额（元）',
                    name: 'giftCostAmount',
                    spanCol: 12,
                    type: 'inputNumber',
                    comConfig: {
                      disabled: !orderRefundType ? true : false,
                      min: 0,
                      precision: 2,
                      onChange: e => {
                        console.log(e)
                        const all = formRef.current?.onFormRef()?.getFieldsValue()
                        console.log(all)
                        all.engineeringPenalty = all.engineeringPenalty || 0
                        const num = all.engineeringPaymentAmount - e - all.engineeringPenalty
                        formRef.current?.onFormRef()?.setFieldsValue({
                          engineeringRefundAmount: num,
                        })
                      },
                    },
                  },
                  {
                    spanCol: 24,
                    label: '赠品扣除说明',
                    name: 'giftCostDescription',
                    type: 'textarea',
                    required: true,
                    comConfig: { showCount: true, maxLength: 200 },
                  },
                  {
                    label: '工程款应退金额（元）',
                    name: 'engineeringRefundAmount',
                    spanCol: 12,
                    isHideItem: orderRefundType === 'refundTypeOrder' ? false : true,
                    comConfig: { disabled: true },
                  },
                  {
                    label: '设计费交款金额（元）',
                    name: 'designFeePaymentAmount',
                    isHideItem:
                      orderRefundType === 'refundTypeOrder' && designFeeAmount ? false : true,
                    spanCol: 12,
                    required: true,
                    comConfig: { disabled: true },
                  },
                  {
                    label: '设计费应退金额（元）',
                    name: 'designFeeRefundAmount',
                    isHideItem:
                      orderRefundType === 'refundTypeOrder' && designFeeAmount ? false : true,
                    type: 'inputNumber',
                    spanCol: 12,
                    required: true,
                    comConfig: {
                      min: 0.01,
                      max: designFeePaymentAmount,
                      precision: 2,
                    },
                  },
                  {
                    label: '设计费违约金（元）',
                    name: 'designerFeePenaltyAmount',
                    isHideItem:
                      orderRefundType === 'refundTypeOrder' && designFeeAmount ? false : true,
                    type: 'inputNumber',
                    spanCol: 12,
                    comConfig: {
                      disabled: true,
                    },
                  },
                  {
                    spanCol: 12,
                    label: '账户类型',
                    name: 'accountNature',
                    type: 'radio',
                    required: true,
                    comConfig: {
                      options: [
                        { label: '对私', value: 'privateAccount' },
                        { label: '对公', value: 'publicAccount' },
                      ],
                    },
                  },
                  {
                    label: '客户开户名',
                    name: 'accountName',
                    spanCol: 12,
                    required: true,
                    rules: [{ required: true, message: '请填写' }],
                    comConfig: {
                      disabled: true,
                    },
                  },
                  {
                    label: '客户银行卡号',
                    name: 'accountNumber',
                    spanCol: 12,
                    // type: 'inputNumber',
                    required: true,
                    rules: [
                      {
                        pattern: /^([1-9]{1})(\d{8,24})$/,
                        message: '请填写正确的银行卡号',
                      },
                    ],
                  },
                  {
                    label: '客户银行名称',
                    name: 'bankCode',
                    spanCol: 12,
                    required: true,
                    data: 'bankList',
                    type: 'select',
                    comConfig: {
                      onChange: () => {
                        getBankAddress()
                      },
                      fieldNames: { label: 'bankName', value: 'bankCode' },
                      labelInValue: true,
                    },
                  },
                  {
                    label: '客户银行省份',
                    name: 'bankAreaCode',
                    spanCol: 12,
                    required: true,
                    data: 'bankAreaList',
                    type: 'select',
                    comConfig: {
                      onChange: () => {
                        getBankAddress()
                      },
                      fieldNames: { label: 'areaName', value: 'areaCode' },
                    },
                  },
                  {
                    label: '客户银行网点',
                    name: 'branchCode',
                    spanCol: 12,
                    required: true,
                    rules: [{ required: true, message: '请填写' }],
                    type: 'select',
                    data: 'bankBranchList',
                    comConfig: {
                      fieldNames: { label: 'branchName', value: 'branchCode' },
                      labelInValue: true,
                    },
                  },
                  {
                    label: '退款原因',
                    name: 'reason',
                    spanCol: 12,
                    required: true,
                    rules: [{ required: true, message: '请填写' }],
                    children: (
                      <Cascader
                        options={reasonList}
                        showSearch
                        expandTrigger="hover"
                        fieldNames={{ label: 'name', value: 'priKey' }}
                        placeholder="请选择退款原因"
                      />
                    ),
                  },
                  {
                    spanCol: 12,
                    label: '是否退款',
                    name: 'realRefundFlag',
                    type: 'radio',
                    required: true,
                    comConfig: {
                      options: [
                        { label: '是', value: true },
                        { label: '否', value: false },
                      ],
                    },
                  },
                  {
                    spanCol: 24,
                    label: '原因备注',
                    name: 'reasonDescription',
                    required: true,
                    type: 'textarea',
                  },
                  {
                    spanCol: 24,
                    label: '附件',
                    children: (
                      <Upload
                        headers={{
                          Authorization: getToken?.(),
                          'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId(),
                        }}
                        accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.md,.jpg,.jpeg,.gif,.bmp,.png,.tiff,.psd"
                        action={baseURL + `file-web/file/upload`}
                        fileList={fileList}
                        beforeUpload={onbeforeUpload}
                        onChange={onUploadChange}
                        maxCount={1}
                        // onPreview={onPreview}
                      >
                        <Button icon={<UploadOutlined />}>上传附件</Button>
                        <p style={{ color: 'rgb(153, 153, 153)' }}>单个文件大小不能超过50M</p>
                      </Upload>
                    ),
                  },
                ],
              },
            ]}
          />
        </div>
      </SDrawerOrModal>
    </div>
  )
}
